import { COLORS, SPACING, TYPOGRAPHY, BORDER_RADIUS } from "../constants/theme"
import { filterInputStyle, primaryButtonStyle, secondaryButtonStyle, tableStyle } from "./commonStyles"

export const filterCardStyle = {
	background: "#f9f9f9",
	padding: `${SPACING.md} ${SPACING.xl}`,
	boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
	marginBottom: SPACING.xl,
	borderRadius: BORDER_RADIUS.lg,
}

export const filterRowStyle = {
	display: "flex",
	flexWrap: "wrap",
	gap: "12px",
	alignItems: "flex-end",
	marginBottom: SPACING.md,
}

export const filterItemStyle = {
	flex: "1 1 220px",
	minWidth: "200px",
}

export const labelStyle = {
	display: "block",
	fontWeight: TYPOGRAPHY.fontWeight.medium,
	fontSize: TYPOGRAPHY.fontSize.xs,
	color: COLORS.gray600,
	marginBottom: "4px",
	textTransform: "none",
}

export const inputStyle = {
	...filterInputStyle,
	width: "100%",
	height: "40px",
}

export const buttonGroupStyle = {
	display: "flex",
	gap: "12px",
	flexWrap: "wrap",
	alignItems: "stretch",
}

export const applyButtonStyle = {
	...primaryButtonStyle,
	padding: "0 24px",
	fontSize: TYPOGRAPHY.fontSize.sm,
	height: "40px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
}

export const exportButtonStyle = {
	...secondaryButtonStyle,
	padding: "0 24px",
	fontSize: TYPOGRAPHY.fontSize.sm,
	background: COLORS.white,
	color: COLORS.primary,
	border: `1px solid ${COLORS.primary}`,
	height: "40px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
}

export const errorStyle = {
	marginTop: SPACING.sm,
	padding: `${SPACING.sm} ${SPACING.md}`,
	backgroundColor: COLORS.dangerLight,
	color: COLORS.dangerDark,
	borderRadius: BORDER_RADIUS.md,
	fontSize: TYPOGRAPHY.fontSize.sm,
	fontFamily: TYPOGRAPHY.fontFamily,
}

export const tableWrapperStyle = {
	overflowX: "auto",
	overflowY: "hidden",
	width: "100%",
	position: "relative",
}

export const paymentTableStyle = {
	...tableStyle,
	minWidth: "1800px",
	tableLayout: "auto",
	overflow: "visible",
}

export const tableCardStyle = {}

export const dropdownTriggerStyle = {
	...inputStyle,
	display: "flex",
	justifyContent: "space-between",
	gap: "8px",
	cursor: "pointer",
	minHeight: "40px",
	padding: "8px 12px",
}

export const dropdownSummaryContainerStyle = {
	flex: 1,
	display: "flex",
	flexDirection: "column",
	gap: "2px",
}

export const dropdownPlaceholderStyle = {
	color: COLORS.gray500,
	fontSize: TYPOGRAPHY.fontSize.sm,
}

export const dropdownSingleValueStyle = {
	fontSize: TYPOGRAPHY.fontSize.sm,
}

export const dropdownMultiValueStyle = {
	fontSize: TYPOGRAPHY.fontSize.xs,
	color: COLORS.gray600,
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis",
}

export const dropdownExtraCountStyle = {
	fontSize: TYPOGRAPHY.fontSize.xs,
	color: COLORS.gray500,
}

export const dropdownMenuStyle = {
	position: "absolute",
	top: "calc(100% + 4px)",
	left: 0,
	right: 0,
	background: COLORS.white,
	border: `1px solid ${COLORS.borderLight}`,
	borderRadius: BORDER_RADIUS.md,
	boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
	zIndex: 10,
	maxHeight: "240px",
	overflowY: "auto",
	padding: "8px",
}

export const dropdownMenuHeaderStyle = {
	padding: "4px 8px",
	borderBottom: `1px solid ${COLORS.borderLight}`,
	marginBottom: "6px",
}

export const dropdownMenuItemStyle = {
	padding: "4px 8px",
}

export const dropdownMenuLabelStyle = {
	display: "flex",
	alignItems: "center",
	gap: "8px",
	fontSize: TYPOGRAPHY.fontSize.sm,
	cursor: "pointer",
}

export const dropdownEmptyStateStyle = {
	padding: "12px 8px",
	textAlign: "center",
	fontSize: TYPOGRAPHY.fontSize.sm,
	color: COLORS.gray500,
}
